import ReactPlayer from 'react-player';
import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styles from '../../styles/Navigator.module.css';
import Image from 'next/image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as LIB from '../../lib/common';

const Navigator = ({ article }) => {

  const jumpArticle = (action) => {
    if (action == 'next' && article.next.id) {
      LIB.viewArticle(article.next.id, article.next.title);
    } else if (action == 'prev' && article.prev.id) {
      LIB.viewArticle(article.prev.id, article.prev.title);
    }
  }

  return (
    <div className={styles.playerWrapper}>
      <div className={styles.player}>
        {/* <Container fluid className={styles.btnHolder}>
          <Row>
            <Col > */}
              <div className={styles.prevBtn} onClick={() => { jumpArticle('prev') }}>上一篇</div>
              {/* <div className={styles.shareBtn} onClick={() => { LIB.copyArticleLink(article.id, article.title) }}>分享</div> */}
              <div className={styles.nextBtn} onClick={() => { jumpArticle('next') }}>下一篇</div>
            {/* </Col>
          </Row>
        </Container> */}
      </div>
    </div>
  );
}

export default Navigator;